/* eslint-disable react/react-in-jsx-scope */
import Navigation from "@/components/layout/Navigation";
import { FC, ReactNode } from "react";

const Layout: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <>
      <Navigation />
      {children}
    </>
  );
};

export default Layout;
